import { RootState } from '@checkout/state';
import { Store, applyMiddleware, compose, createStore } from 'redux';
import { createEpicMiddleware } from 'redux-observable';
import { PersistConfig, persistReducer, persistStore } from 'redux-persist';
// @ts-ignore
import { createWhitelistFilter } from 'redux-persist-transform-filter';
import storage from 'redux-persist/lib/storage';
import { initialState } from '../reducers/checkout';
import createExpirationTransform from '../utils/transformExpire';
import rootEpic from './../epics';
import rootReducer from './../reducers';
import eventsMiddleWare from './eventsMiddleWare';

const composeEnhancers = window &&
  (window as Window).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
  (window as Window).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    serialize: true,
  }) : compose;

const epicMiddleware = createEpicMiddleware();

// Cache data in redux store
const checkoutWhiteListFilter = createWhitelistFilter(
  'checkout',
  [
    'token',
    'intlData',
    'location',
    'countries',
    'paymentMethods',
    'paymentFields',
    ['selection', 'paymentMethod'],
    ['selection', 'items'],
    ['selection', 'discounts'],
    ['selection', 'totals'],
    ['selection', 'shipwallet'],
    ['steps', 'current'],
    // ['widgets'],
    'fieldsData',
    'cartFieldsData',
    'loggedIn',
    'customerClubData',
    'voucherLockExpireDate',
  ]
);

const expireTransform = createExpirationTransform({
  'checkout': {
    expireSpan: 1000 * 60 * 60 * 24 * 14, // 14 days
    default: initialState
  },
});

const persistConfig: PersistConfig = {
  key: 'checkout',
  storage,
  keyPrefix: 'checkoutPersist:',
  transforms: [
    checkoutWhiteListFilter,
    expireTransform
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const configureStore = () => {
  const createdStore: Store<RootState> = createStore(
    persistedReducer,
    composeEnhancers(
      applyMiddleware(epicMiddleware, eventsMiddleWare)
    )
  );
  const persistedStore = persistStore(createdStore);

  const checkoutStore = createdStore;
  (window as Window).store = checkoutStore; // Making store globally available

  return { store: createdStore, persistor: persistedStore };
};

const { store, persistor } = configureStore();

epicMiddleware.run(<any> rootEpic);

export default { store, persistor };
